module.exports = __webpack_public_path__ + "img/World_01.c054be2d.png";